import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import './cursor.css';

export default function SimpleCursor() {
  const [enabled, setEnabled] = useState(false);

  // motion values -> springs give the smooth trailing "lag"
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const spring = { damping: 28, stiffness: 260, mass: 0.5 };
  const sx = useSpring(x, spring);
  const sy = useSpring(y, spring);
  const scale = useSpring(1, { damping: 20, stiffness: 300 });

  useEffect(() => {
    // Only use the custom cursor on devices with a precise pointer (skip touch).
    if (typeof window === 'undefined' ||
        !window.matchMedia('(pointer: fine)').matches) {
      return;
    }
    setEnabled(true);
    document.documentElement.classList.add('has-custom-cursor');

    const interactive = 'a, button, [role="button"], input, textarea, select, .hamburger';

    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => { if (e.target.closest?.(interactive)) scale.set(1.7); };
    const out = (e) => { if (e.target.closest?.(interactive)) scale.set(1); };
    const down = () => scale.set(0.7);
    const up = (e) => scale.set(e.target.closest?.(interactive) ? 1.7 : 1);

    window.addEventListener('mousemove', move);
    document.addEventListener('mouseover', over);
    document.addEventListener('mouseout', out);
    window.addEventListener('mousedown', down);
    window.addEventListener('mouseup', up);
    return () => {
      document.documentElement.classList.remove('has-custom-cursor');
      window.removeEventListener('mousemove', move);
      document.removeEventListener('mouseover', over);
      document.removeEventListener('mouseout', out);
      window.removeEventListener('mousedown', down);
      window.removeEventListener('mouseup', up);
    };
  }, [x, y, scale]);

  if (!enabled) return null;

  return (
    <motion.div className="cursorWrap" style={{ x: sx, y: sy }}>
      <motion.div className="cursorBlob" style={{ scale }} />
    </motion.div>
  );
}
